import { z } from 'zod'

z.config({ jitless: true })

export const MAX_AUDIO_BYTES = 5 * 1024 * 1024
export const MAX_AUDIO_SECONDS = 60

export const leadSchema = z.object({
  name: z.string().trim().min(1).max(120),
  contact: z.string().trim().min(2).max(180),
  details: z.string().trim().max(2000).optional().default(''),
  consent: z.literal('on'),
  honeypot: z.string().max(0).optional().default(''),
  turnstileToken: z.string().max(4096).optional().default(''),
  legacy: z.enum(['0', '1']).optional().default('0'),
})

export function isValidAudio(file: File | null): boolean {
  return Boolean(file && file.size > 0 && file.size <= MAX_AUDIO_BYTES && file.type.startsWith('audio/'))
}
